import { APP_VERSION, getInitials } from '@/utils';
import { Header } from './Header';
import { EditNameModal } from './EditNameModal';
import { EditPasswordModal } from './EditPasswordModal';
import { useGetCurrentUserProfile } from '../hooks/userSettingApi';
import { usePageTitle } from '@/hooks';
import { PageLoading } from '@/components';

export const UserSettingsPage = () => {
  usePageTitle('User Settings');
  const { data: userData, isLoading } = useGetCurrentUserProfile();

  if (isLoading || !userData) {
    return <PageLoading />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="mx-auto max-w-3xl px-4 py-8">
        <div className="rounded-lg border bg-white p-8">
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-900 text-white">
              <span className="text-lg font-medium">
                {getInitials(userData.firstName, userData.lastName)}
              </span>
            </div>

            <div className="flex flex-1 items-center">
              <h2 className="text-xl font-semibold">
                {`${userData.firstName} ${userData.lastName}`}
              </h2>
              <EditNameModal currentUser={userData} />
            </div>
          </div>

          <div className="mt-8">
            <div className="text-popover-foreground mb-2 text-sm font-medium">
              Email
            </div>
            <div className="flex items-center justify-between border-b border-neutral-200 py-4">
              <div className="text-popover-foreground">
                {userData.emailAddress}
              </div>
            </div>
          </div>

          <div className="mt-6">
            <div className="text-popover-foreground mb-2 text-sm font-medium">
              Password
            </div>
            <div className="flex items-center justify-between py-4">
              <div className="text-popover-foreground">••••••••••</div>
              <EditPasswordModal />
            </div>
          </div>
        </div>

        <div className="text-muted-foreground mt-4 text-sm">
          App Version: {APP_VERSION}
        </div>
      </div>
    </div>
  );
};
